const isElementInViewport = (el: HTMLElement): boolean => {
  const rect = el.getBoundingClientRect()

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      Math.min(window.innerHeight, document.documentElement.clientHeight) &&
    rect.right <=
      Math.min(window.innerWidth, document.documentElement.clientWidth)
  )
}

export default isElementInViewport
